import { ExternalUiComponents } from './external-ui-components/ExternalUiComponents';
import { createHashRouter, createRoutesFromElements, Link, Navigate, Route, RouterProvider } from 'react-router-dom';
import { Badges } from './badges/Badges';

const router = createHashRouter(
	createRoutesFromElements([
		<Route path="/external-ui-components" element={<Page content={<ExternalUiComponents />} />} />,
		<Route path="/badges" element={<Page content={<Badges />} />} />,
		<Route path="/" element={<Navigate to="/external-ui-components" />} />
	])
);

function Page(props: { content: React.ReactNode }) {
	return (
		<>
			<header className="header">
				<h1>🌷 Sequential Workflow Designer Pro for React Demo</h1>
				<div className="examples">
					Examples:
					<ul>
						<li>
							<Link to="/external-ui-components" className="btn">
								External ui components
							</Link>
						</li>
						<li>
							<Link to="/badges" className="btn">
								Badges
							</Link>
						</li>
					</ul>
				</div>
			</header>
			{props.content}
		</>
	);
}

export function App() {
	return <RouterProvider router={router} />;
}
